import { churnApis } from '@shared/apis';
import {
  genericMutationWithIdParams,
  genericQuery,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';

export const useGetChurnScores = genericQueryWithParams<churnApis.GetChurnScores>(
  churnApis.getChurnScores
);

export const useGetStudentChurnScore = genericQueryWithId<churnApis.GetStudentChurnScore>(
  churnApis.getStudentChurnScore
);

export const useGetChurnCalibration = genericQuery<churnApis.GetChurnCalibration>(
  churnApis.getChurnCalibration
);

export const useResolveChurn = genericMutationWithIdParams<churnApis.ResolveChurn>(
  churnApis.resolveChurn
);
